var _rect, _g, _circle, _g2, _circle2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _text, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 167.2 249.4",
    enableBackground: "new 0 0 167.2 249.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -5.7,
    y: -5.7,
    fill: "#FCD17F",
    width: 178.6,
    height: 260.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5F5679",
    d: "M150,73.8c1.4-5.1-1.4-8.2-4.8-8.7c-3.1-0.5-4.6,0.4-6.9,4.3c-5.7,9-16.6,12.6-16.6,12.6 c-4.1,1.7-7.2,5.5-7.9,10.2c-1.1,7.2,3.9,13.9,11.1,15c5.5,0.8,10-1.6,13.3-6.3C141.6,96.2,148.6,79,150,73.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M147.9,65.7c-0.9-0.7-2-1.1-3.2-1.1c-1.2,0-2.3,0.4-3.3,1c0.9,0.7,2,1.1,3.2,1.1 C145.8,66.8,147,66.4,147.9,65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M150.5,71.4c0.2-1.1,0.1-2.3-0.4-3.4c-0.5-1.1-1.4-1.9-2.4-2.4c-0.2,1.1-0.1,2.3,0.4,3.4 C148.6,70,149.5,70.9,150.5,71.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#26936C",
    points: "147.8,66 147.5,65.8 148.6,63.4 149.3,63.8  "
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#BA3033",
    cx: 20.8,
    cy: 39.2,
    r: 2.6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 11.6431 28.6079)",
    fontFamily: "'RobotoSlab-Regular'",
    fontSize: 16
  }, "40"))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#BA3033",
    cx: 146.4,
    cy: 210.3,
    r: 2.6
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(-1 0 0 -1 155.5947 220.8426)",
    fontFamily: "'RobotoSlab-Regular'",
    fontSize: 16
  }, "40"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2E2547",
    d: "M73.9,171c-4.7,1-6,4.6-5,7.5c0.9,2.7,2.2,3.6,6.4,3.7c9.7,0.8,17.1,8.1,17.1,8.1c3.1,2.6,7.4,3.5,11.5,2.1 c6.3-2.2,9.6-9,7.4-15.2c-1.6-4.7-5.4-7.4-10.6-8.1S78.7,170,73.9,171z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M68.3,176.1c-0.2,1-0.1,2.1,0.4,3.1s1.3,1.7,2.2,2.2c0.2-1,0.1-2.1-0.4-3.1C70,177.3,69.2,176.5,68.3,176.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M71.7,171.6c-1,0.3-1.9,0.9-2.6,1.8s-1,1.9-1,3c1-0.3,1.9-0.9,2.6-1.8S71.7,172.6,71.7,171.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#26936C",
    points: "68.5,176.1 68.5,176.3 66.1,176.5 66.1,175.7  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5F5679",
    d: "M99.4,235.5c4.2,1.4,6.9-0.8,7.5-3.6c0.5-2.6-0.1-3.8-3.3-5.9c-7.3-5.2-9.7-14.4-9.8-14.4 c-1.3-3.5-4.3-6.2-8.2-7c-6-1.2-11.8,2.7-13,8.6c-0.9,4.5,0.9,8.4,4.7,11.3S95.2,234.1,99.4,235.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M106.3,234.1c0.6-0.7,1-1.6,1.1-2.6c0.1-1-0.2-2-0.7-2.8c-0.6,0.7-1,1.6-1.1,2.6 C105.5,232.4,105.8,233.3,106.3,234.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M101.5,236c0.9,0.2,1.9,0.2,2.8-0.2c0.9-0.4,1.7-1.1,2.1-1.9c-0.9-0.2-1.9-0.2-2.8,0.2 C102.7,234.5,102,235.2,101.5,236z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#26936C",
    points: "106.1,234 106.2,233.8 108.2,234.8 107.8,235.4  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2E2547",
    d: "M89.1,39.4c-0.1-4.3-3.1-6-5.8-5.5c-2.5,0.4-3.5,1.4-4.2,5c-2.2,8.3-9.7,13.7-9.7,13.7 c-2.7,2.3-4.2,6-3.6,9.8c0.9,5.8,6.4,9.8,12.2,8.8c4.4-0.7,7.3-3.6,8.7-8.1S89.3,43.6,89.1,39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M85.5,33.6c-0.9-0.3-1.8-0.4-2.8-0.1c-0.9,0.3-1.7,0.9-2.3,1.6c0.9,0.3,1.8,0.4,2.8,0.1 C84.2,34.9,85,34.4,85.5,33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M88.9,37.3c-0.1-0.9-0.5-1.8-1.2-2.5c-0.7-0.7-1.5-1.1-2.4-1.3c0.1,0.9,0.5,1.8,1.2,2.5 C87.1,36.8,88,37.2,88.9,37.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#26936C",
    points: "85.5,33.8 85.3,33.8 85.5,31.6 86.2,31.8  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#362F44",
    d: "M101.4,45.2c-3.7,5.3-1.6,10.1,2.1,12c3.4,1.7,5.5,1.4,9.7-2.3c10.2-8.2,24.2-8,24.2-8.1 c5.4-0.4,10.5-3.5,13.1-8.7c4.1-7.9,0.9-17.6-7-21.7c-6-3.1-12.1-2.1-17.8,2.1C120,22.7,105.1,39.9,101.4,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M100.7,55.4c0.8,1.2,1.9,2.1,3.3,2.6c1.4,0.5,2.9,0.5,4.2,0.1c-0.8-1.2-1.9-2.1-3.3-2.6S102,55,100.7,55.4z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M99.9,47.9c-0.7,1.2-1,2.6-0.8,4.1c0.2,1.5,0.9,2.8,1.8,3.8c0.7-1.2,1-2.6,0.8-4.1 C101.5,50.2,100.9,48.9,99.9,47.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#26936C",
    points: "100.9,55.2 101.2,55.5 98.9,57.9 98.2,57.1  "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#362F44",
    d: "M60.8,205.2c2.6-5,0.4-8.9-3.1-10.1c-3.1-1.2-4.9-0.6-8.1,3c-7.9,8.1-20,9.4-20,9.5 c-4.6,0.9-8.7,4.1-10.4,8.9c-2.7,7.3,1,15.3,8.3,18c5.5,2,10.7,0.6,15.2-3.7C47.1,226.6,58.2,210.2,60.8,205.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M60.4,196.3c-0.8-0.9-1.8-1.6-3.1-1.9s-2.5-0.1-3.6,0.4c0.8,0.9,1.8,1.6,3.1,1.9 C58,196.9,59.3,196.8,60.4,196.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M61.8,202.7c0.5-1.1,0.6-2.4,0.3-3.6c-0.3-1.3-1-2.3-2-3.1c-0.5,1.1-0.6,2.4-0.3,3.6 C60.2,200.9,60.9,202,61.8,202.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#26936C",
    points: "60.2,196.5 59.9,196.3 61.6,194 62.3,194.6  "
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2E2547",
    d: "M143.6,197.5c2-4.4-0.1-7.1-2.9-8c-2.5-0.8-3.9-0.3-6.3,2.8c-6,6.9-14.9,8.7-14.9,8.7 c-3.7,0.9-7.5,3.5-8.7,7.3c-1.8,5.9,1.4,10.9,7.3,12.7c4.5,1.4,8.6,0,12-3.6S141.8,201.6,143.6,197.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M142.7,190.4c-0.7-0.7-1.6-1.2-2.6-1.3c-1-0.2-2,0-2.9,0.5c0.7,0.7,1.6,1.2,2.6,1.3 C140.9,191,141.9,190.9,142.7,190.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M144.3,195.5c0.3-0.9,0.3-1.9,0-2.9s-1-1.8-1.7-2.3c-0.3,0.9-0.3,1.9,0,2.9 C142.8,194.1,143.5,194.9,144.3,195.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M140.1,193.4c0.7-0.2,1.3-0.5,1.7-1.1c0.5-0.6,0.7-1.3,0.7-1.9c-0.7,0.2-1.3,0.5-1.7,1.1 C140.3,192.1,140.1,192.8,140.1,193.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#26936C",
    points: "142.6,190.6 142.4,190.4 143.6,188.5 144.2,188.9  "
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5F5679",
    d: "M69.8,22c1.9-2.9,0.7-5.1-1.2-6c-1.7-0.8-2.8-0.6-4.8,1.3c-5,4.3-11.5,4.6-11.5,4.6 c-2.7,0.3-5.7,1.7-6.9,4.3c-1.9,4-0.2,7.9,3.8,9.8c3.1,1.5,6.1,0.9,8.9-1.3S68.1,24.7,69.8,22z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M70,16.8c-0.4-0.6-1-1-1.7-1.2c-0.7-0.2-1.4-0.2-2.1,0.1c0.4,0.6,1,1,1.7,1.2C68.6,17.1,69.3,17.1,70,16.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M70.5,20.6c0.3-0.6,0.4-1.3,0.3-2.1s-0.5-1.4-1-1.8c-0.3,0.6-0.4,1.3-0.3,2.1C69.6,19.5,70,20.1,70.5,20.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M67.7,18.7c0.5-0.1,1-0.3,1.3-0.6c0.4-0.4,0.6-0.8,0.7-1.3c-0.5,0.1-1,0.3-1.3,0.6 C68.1,17.8,67.8,18.3,67.7,18.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#26936C",
    points: "69.8,17 69.7,16.8 70.8,15.6 71.1,16  "
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3D335D",
    d: "M27.7,152c-4.1-2.8-7.2-1.1-8.5,1.6c-1.2,2.4-1,3.9,1.7,6.9c5.9,7.2,6.2,16.5,6.3,16.5 c0.3,3.9,2.2,8.1,5.9,10c5.7,2.9,11.3,0.5,14.1-5.2c2.2-4.3,1.4-8.7-1.6-12.7C42.6,165.1,31.6,154.6,27.7,152z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M20.4,151.7c-0.8,0.6-1.5,1.4-1.8,2.4c-0.3,1-0.3,2,0,3c0.8-0.6,1.5-1.4,1.8-2.4 C20.8,153.7,20.7,152.6,20.4,151.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M25.8,151c-0.9-0.5-1.9-0.7-2.9-0.5c-1.1,0.2-2,0.7-2.7,1.4c0.9,0.5,1.9,0.7,2.9,0.5 C24.2,152.2,25.1,151.7,25.8,151z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M23,154.9c-0.1-0.7-0.3-1.4-0.8-1.9c-0.5-0.6-1.2-0.9-1.8-1c0.1,0.7,0.3,1.4,0.8,1.9S22.4,154.8,23,154.9z "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#26936C",
    points: "20.6,151.9 20.4,152.1 18.7,150.5 19.2,150  "
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3D335D",
    d: "M21.8,59.1c-3.1,3-2.2,5.9-0.2,7.5c1.8,1.5,3.1,1.5,6.1-0.2c7.1-3.7,15-2.3,15-2.3c3.3,0.4,7.3-0.4,9.5-3.2 c3.4-4.3,2.4-9.4-1.8-12.8c-3.2-2.6-7-2.8-11-0.9S24.6,56.3,21.8,59.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M20.2,65.2c0.3,0.8,0.9,1.5,1.7,1.9c0.8,0.5,1.7,0.6,2.5,0.5c-0.3-0.8-0.9-1.5-1.7-1.9 C21.9,65.3,21,65.1,20.2,65.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M20.6,60.6c-0.6,0.6-0.9,1.5-1,2.4c-0.1,0.9,0.2,1.8,0.7,2.5c0.6-0.6,0.9-1.5,1-2.4 C21.3,62.1,21,61.3,20.6,60.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M23.3,63.6c-0.6-0.1-1.2,0-1.8,0.4c-0.6,0.3-1,0.8-1.2,1.4c0.6,0.1,1.2,0,1.8-0.4S23.1,64.1,23.3,63.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#26936C",
    points: "20.3,65.1 20.5,65.3 18.8,66.5 18.5,65.9  "
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5F5679",
    d: "M101.4,130.1c4.9,0.7,6.8-2.1,6.9-5.1c0-2.7-0.8-3.9-4.5-5.4c-8.4-3.8-12.7-11.9-12.7-11.9 c-2-3.3-5.5-6.2-9.6-6.3c-6.3-0.1-10.2,4.4-10.2,10.7c0,4.7,2.5,8.3,6.9,10.6C82.6,125,96.9,129.5,101.4,130.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M108,127.2c0.5-0.8,0.7-1.9,0.6-2.9s-0.6-1.9-1.3-2.6c-0.5,0.8-0.7,1.9-0.6,2.9S107.3,126.6,108,127.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M103.6,130.2c1,0,2-0.2,2.8-0.8c0.9-0.6,1.5-1.4,1.8-2.4c-1,0-2,0.2-2.8,0.8 C104.5,128.4,103.9,129.2,103.6,130.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M104.3,125.5c0.4,0.6,0.9,1.1,1.6,1.4c0.7,0.3,1.4,0.3,2.1,0.1c-0.4-0.6-0.9-1.1-1.6-1.4 C105.7,125.4,105,125.4,104.3,125.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#26936C",
    points: "107.8,127.2 107.9,126.9 110.1,127.5 109.8,128.2  "
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 18.4854 159.3316)",
    fontFamily: "'RobotoSlab-Thin'",
    fontSize: 115
  }, "40")), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5F5679",
    d: "M27.6,84.2c-3.9-1.7-6.7,0.2-7.4,2.9c-0.7,2.4-0.2,3.7,2.7,5.9c6.5,5.5,8.1,14.5,8.2,14.5 c0.9,3.4,3.6,6.3,7.2,7.3c5.6,1.6,11.4-1.6,13.1-7.2c1.2-4.2-0.2-8-3.6-11.2C44.3,93.3,31.5,85.9,27.6,84.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M20.9,85c-0.6,0.6-1.1,1.5-1.3,2.4c-0.1,1,0,1.9,0.5,2.7c0.6-0.6,1.1-1.5,1.3-2.4 C21.5,86.7,21.3,85.8,20.9,85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M25.7,83.6c-0.9-0.3-1.8-0.3-2.7,0c-0.9,0.3-1.7,0.9-2.2,1.6c0.9,0.3,1.8,0.3,2.7,0 C24.4,84.9,25.2,84.3,25.7,83.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#26936C",
    points: "21.1,85.1 20.9,85.3 19.2,84.2 19.6,83.6  "
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3D335D",
    d: "M124,143.8c-4.8-1.2-7,1.4-7.4,4.3c-0.3,2.7,0.4,3.9,3.9,5.8c7.9,4.7,11.2,13.3,11.3,13.2 c1.6,3.5,4.8,6.8,8.8,7.3c6.2,0.8,10.6-3.3,11.4-9.5c0.6-4.7-1.5-8.5-5.7-11.3S128.4,145,124,143.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M117.1,146c-0.6,0.8-0.9,1.8-0.9,2.8c0,1,0.4,2,1,2.8c0.6-0.8,0.9-1.8,0.9-2.8 C118.1,147.7,117.7,146.7,117.1,146z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M121.8,143.6c-1-0.1-2,0-2.9,0.5c-0.9,0.5-1.6,1.3-2,2.1c1,0.1,2,0,2.9-0.5 C120.8,145.2,121.4,144.4,121.8,143.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26936C",
    d: "M120.6,148.1c-0.3-0.6-0.8-1.2-1.4-1.5s-1.4-0.5-2.1-0.4c0.3,0.6,0.8,1.2,1.4,1.5 C119.2,148.1,119.9,148.2,120.6,148.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#26936C",
    points: "117.3,146.1 117.2,146.3 115.1,145.4 115.4,144.8  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg40);
export default __webpack_public_path__ + "static/media/40.76c062ecf1ae2e310593f9b91f2b4943.svg";
export { ForwardRef as ReactComponent };